<template>
  <div class="product" v-if="product.skuId">
    <div class="item-common product-coupon" @click="showCoupon">
      <div class="item-cell-hd">
        <label class="label-ui">优惠券</label>
      </div>
      <div class="coupon-ui">
        <div class="chooseCoupon" v-if="!selectedCoupon.couponId">
          <p class="default" v-if="confirmCoupons.usableList.length <= 0">
            暂无可用优惠券
          </p>
          <p class="default" v-else>
            {{ confirmCoupons.usableList.length }}张优惠券可用
          </p>
        </div>
        <div class="chooseCoupon hasCoupon" v-else>
          <p>减免{{ selectedCoupon.couponAmount / 100 }}元</p>
          <div class="roundclosefill-ui" @click.stop="deleteCoupon"></div>
        </div>
        <div
          class="icon-arr-r"
          v-show="confirmCoupons.usableList.length > 0"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { RULETYPE } from '@/plugins/enum'
export default {
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    couponInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapMutations(['changeView', 'setActionHeader', 'setSelectedCoupon']),
    showCoupon() {
      if (
        this.confirmCoupons &&
        this.confirmCoupons.usableList &&
        this.confirmCoupons.usableList.length <= 0
      ) {
        return
      }
      this.changeView('coupon')
      this.setActionHeader({
        title: '优惠券',
        show: false
      })
      // this.showActionSheet();
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
      // 埋点
      // const code = this.selectedWorker.code || ''
      // this.$$tracker('110101', '10000', 21033, code)
    },
    deleteCoupon() {
      this.setSelectedCoupon({})
    }
  },
  computed: {
    ...mapState([
      'selectedCoupon',
      'viewName',
      'couponList',
      'selectedWorker',
      'confirmCoupons'
    ]),

    // 团购和秒杀没有优惠券
    isShowCouponItem() {
      const ruleType = this.$route.query.ruleType || 1
      return (
        ruleType != RULETYPE.SECKILL &&
        ruleType != RULETYPE.GROUP &&
        this.confirmCoupons &&
        this.confirmCoupons.usableList &&
        this.confirmCoupons.usableList.length > 0
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.product {
  border-radius: rem(16px);
  overflow: hidden;
  padding: rem(6px) 0;
  background-color: #fff;
  .product-coupon {
    overflow: hidden;
    .label-tip {
      border: rem(1px) solid #ff5900;
      padding: rem(3px);
      line-height: 0;
      color: #ff5900;
      font-size: rem(20px);
      margin-left: rem(12px);
    }
    .icon-arr-r {
      height: rem(76px);
    }
  }

  .coupon-ui {
    display: flex;
    position: absolute;
    right: rem(40px);
  }
  .chooseCoupon {
    display: flex;
    align-items: center;
    &.hasCoupon {
      padding-right: 0;
      > p {
        background: #fff5f8;
        font-size: rem(22px);
        color: #ff5900;

        line-height: rem(32px);
        padding: 0 rem(10px);
        @include border(all, #ff8800, 1px, 2px);
      }
    }
    p {
      flex: 1;
      text-align: right;
    }

    .default {
      color: #262626;
      text-align: right;
      font-weight: normal;
      font-size: rem(26px);
    }
    .haveCoupon {
      color: #262626;
      font-size: rem(26px);
    }
  }

  .product-detail {
    display: flex;

    align-items: stretch;
    padding: rem(20px) rem(24px);
    .img-ui {
      flex: none;
      border-radius: rem(12px);
      overflow: hidden;
      width: rem(200px);
      height: rem(120px);
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .content-ui {
      flex: auto;
      padding-left: rem(20px);
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .name {
      font-size: rem(28px);
      color: #262626;
      line-height: rem(38px);
      font-weight: 500;
      display: flex;
      justify-content: space-between;
      span {
        &:first-child {
          @include ellicpsis;
        }
        &:last-child {
          flex: none;
          padding-left: rem(10px);
        }
      }
    }
    .specification {
      color: #999;
      margin-top: rem(4px);
      font-size: rem(22px);
    }
    .labels {
      font-size: rem(22px);
      line-height: rem(28px);
      color: #ff5900;
      display: flex;
      > span {
        display: inline-block;
        position: relative;
        padding-right: rem(20px);
        height: rem(28px);
        &.no-refund {
          color: #f5a623;
        }
        &::after {
          display: block;
          content: '';
          position: absolute;
          top: rem(2px);
          bottom: rem(2px);
          right: rem(10px);
          width: 1px;
          background-color: #ff5900;
        }
        &:last-child {
          padding-right: 0;
          &::after {
            width: 0;
          }
        }
      }
    }
  }
}
.roundclosefill-ui {
  width: rem(46px);
  height: rem(34px);
  background: url('~@/assets/images/icon-confirm-delete@3x.png') no-repeat
    center right;
  background-size: rem(34px) auto;
}
</style>
